import React, { useEffect, useState } from 'react'
import API from 'util/onboardApi'
import CardBox from 'components/CardBox'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
// import { Formik } from 'formik'
import ActionsTable from "components/ActionsTable/TableList";
import ContainerHeader from 'components/ContainerHeader'
import SnackBar from 'components/SnackBar'
import * as Yup from "yup";
import _ from "lodash";
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Input from '@material-ui/core/Input'
import { Formik, Form } from 'formik';
import { InputLabel, MenuItem, Button, TextField, Select } from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Slide } from '@material-ui/core';
// import { TimePicker  } from 'formik-material-ui-pickers';
import { TimePicker } from '@material-ui/pickers';
import { enUS } from 'date-fns/locale';

import moment from 'moment';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

const getShiftValidationShape = (jobSlots) => {
  const shiftShape = {};
  jobSlots.forEach((shift) => {
    shiftShape[shift.value] = Yup.object().shape({
      vacancy: Yup.number()
        .min(0, 'Vacancy cannot be negative')
        .test('vacancy-required', 'Vacancy is required if payouts are entered', function (value) {
          const { payouts } = this.parent;
          return payouts > 0 ? value > 0 : true;
        }),
      payouts: Yup.number()
        .min(0, 'Payouts must be non-negative')
        .test('payouts-required', 'Payouts are required if vacancy is entered', function (value) {
          const { vacancy } = this.parent;
          return vacancy > 0 ? value > 0 : true;
        }),
      slotTime: Yup.string()
    });
  });
  return Yup.object().shape(shiftShape);
};

//   const validations = (jobSlots) =>
//     Yup.object().shape({
//       title: Yup.string().required('Required'),
//       location_id: Yup.string().required('Please select a Location'),
//       slots: Yup.array()
//         .of(
//           Yup.object().shape({
//             startDate: Yup.date().required('Start date is required'),
//             endDate: Yup.date()
//               .required('End date is required')
//               .min(Yup.ref('startDate'), 'End date must be after start date'),
//             shift: getShiftValidationShape(jobSlots),
//           })
//         )
//         .min(1, 'At least one slot configuration is required'),
//     });
const validations = () =>
  Yup.object().shape({
    //   clientName: Yup.string().required('Client name is required'),
    location_id: Yup.string().required('Location is required'),
    type: Yup.string().required('Type is required'),
    valet_req: Yup.number().required('Valet Requirement is required').min(1, 'Must be at least 1'),
    car_expected: Yup.number().required('Cars Expected is required').min(1, 'Must be at least 1'),
    dateRange: Yup.mixed().test(
      'dateRange-required',
      'Date range is required',
      function (value) {
        const { type } = this.parent;
        if (type === 'One-Time') {
          return !!value;
        }
        return Array.isArray(value) && value[0] && value[1];
      }
    )
  });

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  datepicker: {
    width: '100%',
    '& .react-datepicker': {
      width: '100%',
      display: 'block',
      fontFamily: 'Nunito',
      boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
      borderRadius: 8,
      overflow: 'hidden',
    },
    '& .react-datepicker__month-container': {
      width: '100%',
    },
    '& .react-datepicker__header': {
      backgroundColor: '#faa719',
      color: '#fff',
      borderBottom: 'none',
    },
    '& .react-datepicker__current-month': {
      color: '#fff',
      fontSize: 18,
      textAlign: 'center',
      marginBottom: 10,
    },
    '& .react-datepicker__day-name, & .react-datepicker__day': {
      flex: '1',
      textAlign: 'center',
      margin: 0,
    },
    '& .react-datepicker__day-names, & .react-datepicker__week': {
      display: 'flex',
      width: '100%',
    },

    // ✅ Start of range
    '& .react-datepicker__day--range-start': {
      backgroundColor: '#faa719 !important',
      color: '#fff',
      borderRadius: '50% 0 0 50%',
    },

    // ✅ Middle of range
    '& .react-datepicker__day--in-range': {
      backgroundColor: '#faa719',
      color: '#fff',
      borderRadius: 0,
    },

    // ✅ End of range
    '& .react-datepicker__day--range-end': {
      backgroundColor: '#faa719 !important',
      // color: '#fff',
      // borderRadius: '0 50% 50% 0',
      // outline: '2px solid red', // temporary for debugging
      // zIndex: 2,
    },
    '&  .react-datepicker__day--selected': {
      backgroundColor: '#faa719',
      color: '#fff',
      // backgroundColor: 'transparent',
    },
    '& .react-datepicker__day--keyboard-selected': {
      backgroundColor: 'transparent',
    },
    '& .react-datepicker__day:hover': {
      backgroundColor: '#faa719',
      color: '#fff',
    },
    '& .react-datepicker__navigation-icon::before': {
      borderColor: '#fff',
      marginTop: '5px',
      height: '12px',
      width: '12px',
    },
    '& .react-datepicker__day-name': {
      color: '#fff',
    },
    '& .react-datepicker__day--in-selecting-range': {
      backgroundColor: '#faa719 !important',
      color: '#fff',
      borderRadius: 0,
    },
  },
}));


// Customize day names
const customLocale = {
  ...enUS,
  localize: {
    ...enUS.localize,
    day: (n) => ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][n],
  },
};
registerLocale('custom-en', customLocale);
const JobList = (props) => {

  const [jobSlots, setJobSlots] = useState([]);
  const [locations, setLocations] = useState([]);
  const [jobType, setJobType] = useState([{ id: 1, value: 'One-Time' }, { id: 2, value: 'Recurring' }]);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [fieldValues, setFieldValue] = useState(false);
  const [dialog, setDialog] = useState({ open: false, fullWidth: true, content: null, header: '', agreeBtnTxt: '', disAgreeBtnTxt: '', disableSubmit: false, type: '', callback: null });
  const classes = useStyles();

  const [jobList, setJobList] = useState();
  const [snackBar, setSnackBar] = useState({
    open: false,
    message: "",
    type: "error",
  });

  // const [initialValues, setInitialValues] = useState({
  //     title: '',
  //     location_id: null,
  //     slots: [
  //         {
  //             startDate: null,
  //             endDate: null,
  //             shift: generateInitialShiftValues(jobSlots),
  //         },
  //     ],
  // });
  const [initialValues, setInitialValues] = useState(
    {
      // clientName: '',
      location_id: null,
      type: 'One-Time',
      valet_req: 0,
      car_expected: 0,
      budget: 0,
      dateRange: null
    })
  useEffect(() => {
    getJobList();
  }, [])

  const getJobList = () => {
    API.get('jobLists').then(res => {
      setLocations(res?.data?.data?.locations);
      setJobList(res?.data?.data?.jobs)
    }).catch(err => {
      setSnackBar({
        open: true,
        message: err?.response?.data?.msg,
        type: "error",
      })
    })
  };

  const editJob = (job) => {
    let jobDetails = _.cloneDeep(job);
    setIsEdit(true);
    const startDate = jobDetails?.slots?.[0]?.startDate; // e.g. "2025-07-22"
    const endDate = jobDetails?.slots?.[0]?.endDate;     // e.g. "2025-07-23"
    const shift = jobDetails?.slots?.[0]?.shift;
    let editJob = {
      valet_req: jobDetails?.valet_req?.value,
      budget: jobDetails?.budget?.value,
      car_expected: jobDetails?.car_expected?.value,
      location_id: jobDetails?.location_id?.value?.value,
      // Combine date + time properly
      startTime: moment(`${startDate} ${shift?.startTime}`, "YYYY-MM-DD HH:mm").toDate(),
      endTime: moment(`${endDate} ${shift?.endTime}`, "YYYY-MM-DD HH:mm").toDate(),
      type: jobDetails?.slots?.[0]?.startDate === jobDetails?.slots?.[0]?.endDate ? 'One-Time' : 'Recurring',
      job_id: jobDetails?.id?.value,
      dateRange: jobDetails?.slots?.[0]?.startDate === jobDetails?.slots?.[0]?.endDate ? new Date(startDate) : [new Date(startDate), new Date(endDate)],
    };
    setInitialValues(editJob);
  };

  const confirmDeleteJob = (job) => {
    setDialog({
      open: true,
      header: `Delete Job`,
      content: `Are you sure you want to delete this job?`,
      submitBtnLabel: 'Confirm',
      disAgreeBtnTxt: 'Cancel',
      userData: job,
      callback: deleteJob,
    });
  }
  const addTimeSlots = (val) => {
    setJobSlots([...jobSlots, val]);
    handleDialogClose();
  }
  const deleteJob = (job) => {
    setDialog({
      open: false,
    })
    API.put('deactivateJob', { job_id: job?.id?.value }).then(res => {
      getJobList();
      setSnackBar({
        open: true,
        message: res?.data?.msg,
        type: "success",
      });
    }).catch(err => {
      setSnackBar({
        open: true,
        message: err?.response?.data?.msg,
        type: "error",
      });
    })
  }
  const handleDialogClose = () => {
    setDialog({
      open: false,
      content: '',
      header: '',
      agreeBtnTxt: '',
      disAgreeBtnTxt: '',
      type: '',
      location: null,
      callback: null
    });
  }
  const submitJob = (values, resetForm) => {
    values.slots = [
      {
        startDate: Array.isArray(values.dateRange) ? moment(values.dateRange[0]).format('YYYY-MM-DD') : moment(values.dateRange).format('YYYY-MM-DD'),
        endDate: Array.isArray(values.dateRange) ? moment(values.dateRange[1]).format('YYYY-MM-DD') : moment(values.dateRange).format('YYYY-MM-DD'),
        shift: {
          startTime: moment(values.startTime).format('HH:mm'),
          endTime: moment(values.endTime).format('HH:mm'),
        },
      },
    ];
    if (!isEdit) {
      API.post('jobPost', values).then(res => {
        resetForm();
        getJobList();
        setIsLoading(false);
        setSnackBar({
          open: true,
          message: res?.data?.msg,
          type: "success",
        });
      }).catch(err => {
        setIsLoading(false);
        setSnackBar({
          open: true,
          message: err?.response?.data?.msg,
          type: "error",
        });
      })
    }
    else {
      API.put('jobEdit', values).then(res => {
        resetFormValues(resetForm);
        getJobList();
        setIsEdit(false);
        setIsLoading(false);
        setSnackBar({
          open: true,
          message: "Job updated Successfully",
          type: "success",
        });
      }).catch(err => {
        setIsLoading(false);
        setSnackBar({
          open: true,
          message: "Something went wrong",
          type: "error",
        });
      })
    }
    setJobSlots([]);
  }

  const handleDateSelection = (values, setFieldValue) => {
    if (values)
      setDialog({
        open: true,
        header: `Add Slot`,
        content: <CustomDatePicker values={values} setFieldValue={setFieldValue} onChangeVal={(val) => { setFieldValue('dateRange', val) }} />,
        submitBtnLabel: 'Confirm',
        disAgreeBtnTxt: 'Cancel',
        // userData: job,
        // addSlot: true,
        callback: addTimeSlots,
      });
  }


  const resetFormValues = (resetForm) => {
    setIsEdit(false);
    resetForm();
    setInitialValues({
      clientName: '',
      location: null,
      type: 'One-Time',
      valet_req: 0,
      car_expected: 0,
      budget: 0,
      dateRange: null
    });
  };

  // const CustomDatePicker = ({ values, onChangeVal, setFieldValue }) => {
  //     const isRange = values.type !== 'One-Time';

  //     const [internalRange, setInternalRange] = useState([null, null]);
  //     const [internalStartTime, setInternalStartTime] = useState(null);
  //     const [internalEndTime, setInternalEndTime] = useState(null);

  //     useEffect(() => {
  //       // Date
  //       if (isRange) {
  //         const newRange = values?.dateRange || [null, null];
  //         const [s1, e1] = internalRange;
  //         const [s2, e2] = newRange;
  //         if (s1 !== s2 || e1 !== e2) setInternalRange(newRange);
  //       } else {
  //         const oneTimeDate = values?.dateRange || null;
  //         if (internalRange[0] !== oneTimeDate) {
  //           if (Array.isArray(oneTimeDate)) {
  //             setInternalRange([oneTimeDate[0]]);
  //           } else {
  //             setInternalRange([oneTimeDate]);
  //           }
  //         }
  //       }

  //       // Time
  //       if (values.startTime) setInternalStartTime(values.startTime);
  //       if (values.endTime) setInternalEndTime(values.endTime);
  //     }, []);

  //     const handleDateChange = (update) => {
  //       if (isRange) {
  //         setInternalRange(update);
  //         onChangeVal(update);
  //         setFieldValue('dateRange', update);
  //       } else {
  //         const selectedDate = update?.[1] || update?.[0];
  //         setInternalRange([selectedDate, selectedDate]);
  //         onChangeVal(selectedDate);
  //         setFieldValue('dateRange', selectedDate);
  //       }
  //     };

  //     const handleStartTimeChange = (time) => {
  //       setInternalStartTime(time);
  //       setFieldValue('startTime', time);
  //     };

  //     const handleEndTimeChange = (time) => {
  //       setInternalEndTime(time);
  //       setFieldValue('endTime', time);
  //     };

  //     return (
  //       <div className='row'>
  //         {isRange ? (
  //           <div className={`col-md-12 col-12 mb-3 ${classes?.datepicker}`}>
  //             <InputLabel shrink={true} htmlFor="dateRange">
  //               Select Date
  //             </InputLabel>
  //             <DatePicker
  //               selectsRange
  //               startDate={internalRange[0]}
  //               endDate={internalRange[1]}
  //               onChange={handleDateChange}
  //               isClearable
  //               inline
  //               fullWidth
  //               minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
  //               maxDate={new Date(new Date().setDate(new Date().getDate() + 30))}
  //             />
  //           </div>
  //         ) : (
  //           <div className={`col-md-12 col-12 mb-3  ${classes?.datepicker}`}>
  //             <InputLabel shrink={true} htmlFor="dateRange">
  //               Select Date
  //             </InputLabel>
  //             <DatePicker
  //               selected={internalRange[0]}
  //               onChange={(date) => handleDateChange([date, date])}
  //               isClearable
  //               inline
  //               fullWidth
  //               minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
  //             />
  //           </div>
  //         )}

  //         <div className="row">
  //           <div className="col-md-6 col-12 mb-3">
  //             <InputLabel shrink htmlFor="startTime">Start Time</InputLabel>
  //             <TimePicker
  //               value={internalStartTime}
  //               onChange={handleStartTimeChange}
  //               inputVariant="outlined"
  //               fullWidth
  //               minutesStep={30}
  //               ampm={true}
  //               TextFieldComponent={TextField}
  //             />
  //           </div>

  //           <div className="col-md-6 col-12 mb-3">
  //             <InputLabel shrink htmlFor="endTime">End Time</InputLabel>
  //             <TimePicker
  //               value={internalEndTime}
  //               onChange={handleEndTimeChange}
  //               inputVariant="outlined"
  //               fullWidth
  //               minutesStep={30}
  //               ampm={true}
  //               TextFieldComponent={TextField}
  //             />
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   };
  const CustomDatePicker = ({ values, onChangeVal, setFieldValue }) => {
    const isRange = values.type !== 'One-Time';

    const [internalRange, setInternalRange] = useState([null, null]);
    const [internalStartTime, setInternalStartTime] = useState(null);
    const [internalEndTime, setInternalEndTime] = useState(null);

    useEffect(() => {
      // Initialize date range
      if (isRange) {
        const newRange = values?.dateRange || [null, null];
        setInternalRange(newRange);
      } else {
        const oneTimeDate = values?.dateRange || null;
        if (Array.isArray(oneTimeDate)) {
          setInternalRange([oneTimeDate[0], oneTimeDate[0]]);
        } else {
          setInternalRange([oneTimeDate, oneTimeDate]);
        }
      }

      // Initialize time
      if (values.startTime) setInternalStartTime(values.startTime);
      if (values.endTime) setInternalEndTime(values.endTime);
    }, [values?.dateRange, values?.startTime, values?.endTime, values?.type]);

    const handleDateChange = (update) => {
      if (isRange) {
        setInternalRange(update);
        onChangeVal(update);
        setFieldValue('dateRange', update);
      } else {
        const selectedDate = update?.[1] || update?.[0];
        setInternalRange([selectedDate, selectedDate]);
        onChangeVal(selectedDate);
        setFieldValue('dateRange', selectedDate);
      }
    };

    const handleStartTimeChange = (time) => {
      setInternalStartTime(time);
      setFieldValue('startTime', time);
    };

    const handleEndTimeChange = (time) => {
      setInternalEndTime(time);
      setFieldValue('endTime', time);
    };

    return (
      <div className="row">
        <div className={`col-md-12 col-12 mb-3 ${classes?.datepicker}`}>
          <InputLabel shrink={true} htmlFor="dateRange">
            Select Date{isRange ? ' Range' : ''}
          </InputLabel>
          <div className="datepicker-wrapper">
            {isRange ? (
              <DatePicker
                selectsRange
                startDate={internalRange[0]}
                endDate={internalRange[1]}
                onChange={handleDateChange}
                isClearable
                inline
                locale="custom-en"
                minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
                maxDate={new Date(new Date().setDate(new Date().getDate() + 30))}
              />
            ) : (
              <DatePicker
                selected={internalRange[0]}
                onChange={(date) => handleDateChange([date, date])}
                isClearable
                inline
                locale="custom-en"
                minDate={new Date(new Date().setDate(new Date().getDate() + 3))}
              />
            )}
          </div>
        </div>

        {/* Time Pickers */}
        <div className="col-md-6 col-12 mb-3">
          <InputLabel shrink htmlFor="startTime">Start Time</InputLabel>
          <TimePicker
            value={internalStartTime}
            onChange={handleStartTimeChange}
            inputVariant="outlined"
            fullWidth
            minutesStep={30}
            ampm={true}
            TextFieldComponent={TextField}
          />
        </div>

        <div className="col-md-6 col-12 mb-3">
          <InputLabel shrink htmlFor="endTime">End Time</InputLabel>
          <TimePicker
            value={internalEndTime}
            onChange={handleEndTimeChange}
            inputVariant="outlined"
            fullWidth
            minutesStep={30}
            ampm={true}
            TextFieldComponent={TextField}
          />
        </div>
      </div>
    );
  };



  return (
    <>
      <ContainerHeader title={`Job List`} />
      {true &&
        <CardBox styleName="col-12 p-0" >
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validations()}
            validateOnBlur={true}
            validateOnChange={true}
            validateOnMount={true}
            onSubmit={(values, { resetForm }) => {
              submitJob(values, resetForm);
            }}
          >
            {({ values, handleChange, handleBlur, setFieldValue, errors, touched, isSubmitting, resetForm, validateForm, handleSubmit }) => (
              <Form>
                <div className='row'>
                  {/* <div className="col-md-4 col-12 mb-3">
                                <InputLabel shrink={true} htmlFor="clientName">
                                Client
                                </InputLabel>
                                <TextField
                                    name="clientName"
                                    margin="none"
                                    value={values.clientName}
                                    onChange={handleChange} 
                                    onBlur={handleBlur} 
                                    fullWidth
                                />
                                {errors.clientName && touched.clientName && <div style={{ color: 'red' }}>{errors.clientName}</div>}
                            </div> */}
                  <div className="col-md-4 col-12 mb-3">
                    <InputLabel shrink={true} htmlFor="location_id">
                      Location
                    </InputLabel>
                    <Select
                      value={values.location_id}
                      style={{ minWidth: '100%' }}
                      onChange={(e) => {
                        const {
                          target: { value },
                        } = e;
                        setFieldValue('location_id', value);
                      }}
                      name="location"
                      input={<Input style={{ textAlign: 'left' }} id="location" />}
                    >
                      {locations.map((item, i) => (
                        <MenuItem
                          key={"location-" + item.id}
                          value={item.id}
                          data-id={item.id}
                        >
                          {item.location_name}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.location_id && touched.location_id && <div style={{ color: 'red' }}>{errors.location_id}</div>}
                  </div>
                  {/* <div className="col-md-4 col-12 mb-3">
                                <InputLabel shrink={true} htmlFor="client">
                                    Select Location
                                </InputLabel>
                                <GMapInput name="location" value={values.location} setFieldValue={setFieldValue}/>
                                {errors.location && touched.location && <div style={{ color: 'red' }}>{errors.location}</div>}
                            </div> */}
                  <div className="col-md-4 col-12 mb-3">
                    <InputLabel shrink={true} htmlFor="client">
                      Type
                    </InputLabel>
                    <Select
                      value={values.type}
                      style={{ minWidth: '100%' }}
                      onChange={(e) => {
                        const {
                          target: { value },
                        } = e;
                        setFieldValue('type', value);
                        if (value === 'One-Time')
                          setFieldValue('dateRange', null);
                        else setFieldValue('dateRange', null);
                      }}
                      name="state"
                      input={<Input style={{ textAlign: 'left' }} id="state" />}
                    >
                      {jobType.map((item, i) => (
                        <MenuItem
                          key={"type-" + item.id}
                          value={item.value}
                          data-id={item.id}
                        >
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.type && touched.type && <div style={{ color: 'red' }}>{errors.type}</div>}

                  </div>
                  <div className="col-md-4 col-12 mb-3">
                    <InputLabel shrink={true} htmlFor="valet_req">
                      Valet Requirement
                    </InputLabel>
                    <TextField
                      name="valet_req"
                      margin="none"
                      value={values.valet_req}
                      type="number"
                      onChange={(e) => {
                        const val = e.target.value;
                        handleChange(e); // Update Formik's `valetReq`
                        if (!isNaN(val) && val !== '') {
                          setFieldValue('car_expected', parseInt(val) * 10);
                          setFieldValue('budget', parseInt(val) * 2000);
                        } else {
                          setFieldValue('car_expected', '');
                          setFieldValue('budget', '');
                        }
                      }}
                      onBlur={handleBlur}
                      fullWidth
                    />
                    {errors.valet_req && touched.valet_req && <div style={{ color: 'red' }}>{errors.valet_req}</div>}

                  </div>

                  <div className="col-md-4 col-12 mb-3">
                    <InputLabel shrink={true} htmlFor="car_expected">
                      Cars Expected
                    </InputLabel>
                    <TextField
                      name="car_expected"
                      margin="none"
                      value={values.car_expected}
                      type="number"
                      onChange={(e) => {
                        const val = e.target.value;
                        handleChange(e); // Update Formik's `carsExp`
                        if (!isNaN(val) && val !== '') {
                          setFieldValue('valet_req', Math.ceil(parseInt(val) / 10));
                          setFieldValue('budget', (Math.ceil(parseInt(val) / 10)) * 2000);
                        } else {
                          setFieldValue('valet_req', '');
                          setFieldValue('budget', '');
                        }
                      }}
                      onBlur={handleBlur}
                      fullWidth
                    />
                    {errors.car_expected && touched.car_expected && <div style={{ color: 'red' }}>{errors.car_expected}</div>}

                  </div>
                  <div className="col-md-4 col-12 mb-3">
                    <InputLabel shrink={true} htmlFor="budget">
                      Budget
                    </InputLabel>
                    <TextField
                      name="budget"
                      margin="none"
                      value={values.budget}
                      type="number"
                      disabled={true}
                      onBlur={handleBlur}
                      fullWidth
                    />
                    {errors.budget && touched.budget && <div style={{ color: 'red' }}>{errors.budget}</div>}

                  </div>
                  <div className={`col-md-4 col-12 mb-3 ${classes.datepicker}`}>
                    <InputLabel shrink={true} htmlFor="dateRange">
                      Select Date
                    </InputLabel>
                    <Button
                      variant="text"
                      color="secondary"
                      size='large'
                      className={classes.mapButton}
                      onClick={() => handleDateSelection(values, setFieldValue)}
                      startIcon={<CalendarTodayIcon color='primary' />}
                      style={{ justifyContent: 'left', marginTop: '5px' }}
                    >
                      {!values.dateRange ? 'Select the Date' : !Array.isArray(values.dateRange) ? moment(new Date(values.dateRange)).format('YYYY-MM-DD') : moment(new Date(values.dateRange[0])).format('DD-MM-YYYY') + ' - ' + moment(new Date(values.dateRange[1])).format('DD-MM-YYYY')}
                    </Button>
                    {errors.dateRange && touched.dateRange && <div style={{ color: 'red' }}>{errors.dateRange}</div>}
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12 col-12 pl-0">
                  <Box mt="20px">
                    <Box mr="10px" display="inline"><Button variant="contained" color="primary" mr="5px" type="submit" disabled={loading} > {isEdit ? "Update" : "Submit"} </Button></Box>
                    <Box mr="10px" display="inline"><Button variant="outlined" onClick={() => resetFormValues(resetForm)} color="secondary" type="reset" disabled={loading}>Reset</Button></Box>
                  </Box>
                </div>
              </Form>
            )}
          </Formik>
        </CardBox>
      }

      {jobList &&
        <div className="row">
          <ActionsTable
            tableHeading={jobList.title}
            table={jobList}
            // handleImageDialog={ShowImages}
            actions={true}
            onEdit={editJob}
            onDelete={confirmDeleteJob}
          />
        </div>
      }

      <Dialog
        open={dialog.open}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth='sm'
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <LinearProgress style={{ visibility: props.showProgress ? 'visible' : 'hidden' }} color="primary" />
        <DialogTitle id="alert-dialog-slide-title" sx={{ borderBottom: "1px solid red" }} style={{ textAlign: "center" }}>{dialog.header}</DialogTitle>
        <DialogContent>
          {dialog.content}
        </DialogContent>
        {
          dialog?.addSlot &&
          <div className='p-3'>
            <Formik
              initialValues={{ title: null }}
              onSubmit={(values) => {
                const newId = jobSlots.length > 0 ? jobSlots[jobSlots.length - 1].id + 1 : 1;

                // setJobSlots((prev) => {
                //   return [...prev, { id: newId, value: values.title.toUpperCase() }];
                // });
                dialog.callback({ id: newId, value: values.title.toUpperCase() })
                // handleDialogClose();
              }}
            >
              {({ values, handleChange, handleBlur }) => (
                <Form>
                  <div className='row justify-content-center'>
                    <div className="col-md-12 col-12 mb-3 ">
                      <InputLabel shrink={true} htmlFor="title">
                        Shift Timings
                      </InputLabel>
                      <TextField
                        name="title"
                        margin="none"
                        placeholder='Full Time/Part Time  10AM - 02PM '
                        value={values.title}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </div>
                  </div>
                  <DialogActions>
                    {dialog.submitBtnLabel &&
                      <Button variant="outlined" color="primary" type='submit'> {dialog.submitBtnLabel} </Button>
                    }
                    <Button variant="outlined" color="secondary" onClick={handleDialogClose}> Close</Button>
                  </DialogActions>
                </Form>

              )}

            </Formik>

          </div>
        }
        {
          !dialog?.addSlot &&
          <DialogActions>
            {dialog.submitBtnLabel &&
              <Button variant="outlined" color="primary" onClick={() => { dialog.callback(dialog.userData) }} disabled={dialog.disableSubmit} > {dialog.submitBtnLabel} </Button>
            }
            <Button variant="outlined" color="secondary" onClick={handleDialogClose}> Close</Button>
          </DialogActions>
        }
      </Dialog>
      <SnackBar
        {...snackBar}
        handleClose={() => {
          setSnackBar({ open: false, message: "" });
        }}
      />
    </>
  )

}

export default JobList;